import styled from 'styled-components';

export const FlexStyled = styled(({ wrap, vertical, gap, align, ...rest }) => <div {...rest} />)`
  display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};
  align-items: ${(props) => props.align};
  justify-content: ${(props) => props.justify};
  gap: ${(props) => {
    const g = props.gap;
    if (g == null || g === '') return;
    if (typeof g === 'boolean') return;
    return typeof g === 'number' ? `${g}px` : g;
  }};
  flex: ${(props) => props.flex};
  flex-wrap: ${(props) => props.wrap && 'wrap'};
  flex-direction: ${(props) => props.vertical && 'column'};
`;

FlexStyled.displayName = 'FlexStyled';
